import * as globalActionTypes from "./actionTypes";
export const enablePartySearchBar = (data) => {
  return {
    type: globalActionTypes.ENABLE_SEARCHBAR,
    payload: data,
  };
}